<script setup lang="ts">
import { onMounted, ref } from 'vue'

// Full-bleed background artwork for the dark marketing heroes. The parent section must be
// `relative overflow-hidden`; the image fades into the slate-900 page towards the bottom.
withDefaults(defineProps<{ src: string; width: number; height: number; alt?: string }>(), { alt: '' })

const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})
</script>

<template>
  <img
    :src="src"
    :width="width"
    :height="height"
    :alt="alt"
    fetchpriority="high"
    class="absolute inset-0 w-full h-full object-cover opacity-60 motion-safe:transition-transform motion-safe:duration-[2000ms]"
    :class="mounted ? 'scale-100' : 'motion-safe:scale-105'"
  />
  <div class="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent" aria-hidden="true"></div>
</template>
